<template>  
  <myHeader /> 
  <div style="display: flex; flex-direction: row; justify-content: center"> 
    <leftSideBar style="width:10%"/>

    <table style="border: 0px solid red;">
      <tr> 
        <td class="item"> 
          <table  style="width:100%; height:100%; border: 0px solid white;">  
            <tr> 
              <td class="goto"> 
                <a href="residue.html" style="display: flex; flex-direction: column; align-items: center; text-decoration: none;"> 
                  <div class="text">  Start with Residue Target </div>
                  <img src="s/img/misc/start_with_residue.png" style="width:275px; height:200px" /> 
                </a>
              </td> <td> </td> <td> </td>
            </tr>
            <tr> <td> </td>  <td  class="text" > or </td> <td> </td> </tr>
            <tr> 
              <td> </td> <td> </td> <td class="goto"> 
                <a href="warhead.html" style="display: flex; flex-direction: column; align-items: center; text-decoration: none;"> 
                  <img src="s/img/warhead/Aldehyde.svg" style="width:90px; height:90px" /> 
                  <div class="text" style="text-decoration: none;"> Start with Warhead </div>
                </a>
              </td>
            </tr>
          </table> 
        </td>

        <td class="item"> 
          <div style="text-align: center; font-size:2em; font-weight:bold ">
            Match Covalent Binder
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center"> 
            <form id="newPostionForSketcher" method="POST" action="binder.html" style=" display: flex; flex-direction: column; margin-right:20px; border:3px solid #d9e6f2; width: 200px">  
              <textarea    id="search_box_smiles" 
                         name="smiles" 
                      v-model="smiles" 
                       onblur="update_SketcherCanvas()" 
                         rows="9" 
                  placeholder="SMILES String" > 
              </textarea>  
              <input type="submit" name="submit" value="Search"> 
              <div style="font-size: 18px; margin-left:5px; margin-top:5px;" >Options: <br/> 
                <input type="radio" name="opt" value="exa" style="margin-left:12px"> Exact <br/>
                <input type="radio" name="opt" value="sub" style="margin-left:12px" checked="checked"> Substructure <br/>
                <input type="radio" name="opt" value="sim" style="margin-left:12px"> Similarity: 
                <input type="text"  name="value" value="0.6" style="width:40px; border:1px solid #ccc;" placeholder="0-1">    
              </div> 
            </form> 
          </div> 
        </td>

      </tr>
      <tr>
        <td class="item"> 
          <residuePieChart canvas_id="residue" title="Residue Target Popularity of Binders" /> 
        </td>
        <td class="item"> 
          <div style="display: flex; flex-direction: row; justify-content: center">
            <div style="display: flex; flex-direction: column; justify-content: center">
              <button v-for="(_,residueName) in warheadStatData" 
                      :key="residueName" 
                      v-on:click="reDrawPieChart(residueName)"
              >
                {{ residueName }}
              </button> 
            </div>
            <warheadPieChart canvas_id="warhead" title="Warhead Popularity of Binders"/>  
          </div>  
        </td>
      </tr> 
    </table>
    <div style="width:10%"></div>
  </div>  
</template>
 
 
<script>
  import           axios from 'axios';
  import        myHeader from '@/components/header.vue' ;
  import     leftSideBar from '@/components/index/leftSideBar.vue'
  import residuePieChart from "@/components/index/pieChart.vue";
  import warheadPieChart from "@/components/index/pieChart.vue"; 

  export default {
    name: 'App',  
    data () {
      return { 
        warheadStatData: {}, 
        smiles: 'O=C1CCO1',
        sketcher: null,
        oldMolBlock: null, 
      }
    }, 
    components: {
      myHeader,
      leftSideBar,  
      residuePieChart, 
      warheadPieChart
    },
    mounted () {
      axios.get('frontPageData')
            .then(response => {  
              this.warheadStatData = response.data.warheadStatData;
              residuePieChart.methods.draw('residue', response.data.residueStatData);  
              warheadPieChart.methods.draw('warhead', this.warheadStatData.All);    
              var sketcherAtOldPostion  = document.getElementById("sketcherAtOldPostion");
              var newPostionForSketcher = document.getElementById("newPostionForSketcher");
              newPostionForSketcher.parentNode.insertBefore(sketcherAtOldPostion, newPostionForSketcher)
              sketcherAtOldPostion.style.display = 'block' 
            }) 

    },
    methods: {  
      reDrawPieChart: function (residueName) {  
        console.log(residueName, this.warheadStatData[residueName]);
        warheadPieChart.methods.draw('warhead', this.warheadStatData[residueName]);   
      },   
    }
  } 

</script> 
 
<style scoped>    
  .item { 
    border: 1px solid rgb(204, 204, 204);
    margin: 150px;
  }  
  .item:hover {
    border: 1px solid black; 
  }
  .goto {
    border: 1px solid rgb(255, 255, 255);
    
  }
  .goto:hover {
    border: 1px solid rgb(128, 128, 128);
    
  }
  img[alt="center"] {
    max-height:300px;
    width: auto;
    border: 0px solid blue;
    position: absolute;
    top:50%;
    left:50%;
    transform:translate(-50%, -44%);
    z-index:-1
  }  
  .text { 
    text-align: center; 
    color:black;
    font-size:2em; 
    font-weight:bold
  }
  
</style>   